import {ref} from 'vue';

export default {
    install: (app, options) => {
        const companyAvailablePlans = ref([]);

        const loadCompanyAvailablePlans = (companyId) => {
            window.lazy_axios.get(`/companies/${companyId}/plans`)
                .then((response) => {
                    if (response.data.plans) {
                        companyAvailablePlans.value = response.data.plans;
                    }
                });
        };

        app.provide('companyAvailablePlans', companyAvailablePlans);
        app.provide('loadCompanyAvailablePlans', loadCompanyAvailablePlans);
    },
}
